var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8417 16.6525L14.3242 13.1335C16.9562 9.61622 16.2385 4.63123 12.7212 1.99924C9.20398 -0.632757 4.219 0.0849024 1.58701 3.60216C-1.04499 7.11943 -0.327329 12.1044 3.18993 14.7364C6.01529 16.8506 9.89585 16.8506 12.7212 14.7364L16.2403 18.2554C16.6825 18.6977 17.3995 18.6977 17.8417 18.2554C18.2839 17.8132 18.2839 17.0962 17.8417 16.654L17.8417 16.6525ZM7.98491 14.0572C4.85894 14.0572 2.32486 11.5231 2.32486 8.39715C2.32486 5.27117 4.85894 2.7371 7.98491 2.7371C11.1109 2.7371 13.645 5.27117 13.645 8.39715C13.6416 11.5217 11.1095 14.0539 7.98491 14.0572Z",
    fill: "#828C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.26ebea97bccaa6e55cf63f1bbcd90ea9.svg";
export { ForwardRef as ReactComponent };